import { createContext } from 'react';

import { IBDHostResults } from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  hostData: IBDHostResults;
  totalRecords: number;
}

export default createContext<Context>({
  loading: false,
  hostData: null,
  totalRecords: 0,
});
